// Boarding tickets of the tours booked in chey (see netlify/lib/cheyTours.mjs) and their live seats:
// the texts live in netlify/lib/ticketCopy.mjs, shared with the confirmation email the server sends.
import { TICKET_COPY, ticketCopyFor } from '../../../../netlify/lib/ticketCopy.mjs';

export default {
  boardingPass: TICKET_COPY.es,
  boardingPassMamangua: ticketCopyFor('es', 'mamangua'),
  boardingPassMataAtlantica: ticketCopyFor('es', 'mataAtlantica'),
  boardingPassTrindade: ticketCopyFor('es', 'trindade'),
};
